export const BillingDestinations = [
  {key: "NONE", value: "Non-Billable"},
  {key: "SAP-AM", value: "SAP Americas"},
  {key: "SAP-EMEA", value: "SAP EMEA"},
  {key: "SAP-AP", value: "SAP Asia Pacific"},
];

export const PricingModels = [
  {key: 1, value: "Click (color by page)"},
  {key: 2, value: "Click (color by device)"},
  {key: 3, value: "Pages Included"},
  {key: 4, value: "Level Pay"},
  {key: 5, value: "Base+Click (color by page)"},
  {key: 6, value: "Base+Click (color by device)"},
];

export const ServiceTypes = [
  {key: 1, value: "Managed"},
  {key: 2, value: "Transactional"},
];
